import request from '@webtrader/core/request';

export interface ICountryStoneinnoDetail {
  country: string;
  dialCode: string;
  id: number;
  countryCode: string;
}

const retrieveStoneinnoCountryDetails = () => {
  return request.get<ICountryStoneinnoDetail[]>('/api/account/v1/sicountry');
};

export default retrieveStoneinnoCountryDetails;
